/* eslint-disable prefer-destructuring */

export default function startWorker() {
    const SLOW_RENDER_TIME = 3 * 1000; // 3秒判断为卡顿
    const SLOWER_RENDER_TIME = 10 * 1000; // 一次10秒卡顿
    const EDIT_IN_RANGE_TIME = 60 * 1000; // 1分钟内连续三次卡顿判断为最终卡顿
    const SLEEP_RENDER_TIME = 15 * 1000; // 一次卡顿超过15s的，认为是设备休眠引发，忽略

    let slowRenderCount = 0;
    let lastRenderTimeGlobal = 0;
    let nowRenderTimeGlobal = 0;
    let firstSlowTime = 0; // 首次卡顿时间
    let renderTimes: number[] = [];
    let timeFrameInter = 0;
    let slowRenderTimeInterval;
    let hasResultFromMain = true; // 主线程是否回包，默认为true

    let hasReportSlowRenderOld = false;
    let hasReportSlowRenderNew = false;

    function slowRenderMonitor() {
        if (!hasResultFromMain) { // 等待主线程回包，再继续计算
            return;
        }
        nowRenderTimeGlobal = Date.now();

        // 新版卡顿判断
        newSlowRenderJudge(lastRenderTimeGlobal, nowRenderTimeGlobal);
        // 旧版卡顿判断
        oldSlowRenderJudge(lastRenderTimeGlobal, nowRenderTimeGlobal);

        lastRenderTimeGlobal = nowRenderTimeGlobal;
        if (hasResultFromMain) {
            postMessage({
                cmd: 'send',
            });
            hasResultFromMain = false;
        }
    }

    /**
     * 旧版卡顿判断逻辑
     * @param lastRenderTime 上次渲染时间
     * @param nowRenderTime 本地渲染时间
     */
    // eslint-disable-next-line complexity
    function oldSlowRenderJudge(lastRenderTime: number, nowRenderTime: number) {
        timeFrameInter = nowRenderTime - lastRenderTime;
        if (!hasReportSlowRenderOld && lastRenderTime > 0 && (timeFrameInter > SLOW_RENDER_TIME)) {
            slowRenderCount += 1;
            renderTimes.push(lastRenderTime);
            if (!firstSlowTime) {
                firstSlowTime = lastRenderTime;
            }
            let isSlowerRender = false;
            if (timeFrameInter > SLOWER_RENDER_TIME) {
                isSlowerRender = true;
            }
            if (slowRenderCount >= 3 || isSlowerRender) {
                if (nowRenderTime - firstSlowTime <= EDIT_IN_RANGE_TIME || isSlowerRender) {
                    hasReportSlowRenderOld = true;
                    stopIt();
                    // 发送消息到主线程进行上报
                    postMessage({
                        cmd: 'reportOld',
                        args: {
                            isSlowerRender,
                            lastFrameTime: timeFrameInter,
                        },
                    });
                } else if (renderTimes.length >= 3) {
                    while (renderTimes.length >= 3) {
                        renderTimes.shift();
                    }
                    firstSlowTime = renderTimes[0];
                }
            }
        }
    }

    function newSlowRenderJudge(lastRenderTime: number, nowRenderTime: number) {
        timeFrameInter = nowRenderTime - lastRenderTime;
        if (
            hasReportSlowRenderNew
            || lastRenderTime <= 0
            || (timeFrameInter < SLOW_RENDER_TIME)
            || (timeFrameInter > SLEEP_RENDER_TIME)
        ) {
            // 已上报 || 没有起点 || 耗时未到阈值 || 超过15s的（这种一般情况是设备休眠了）  则直接返回
            return;
        }
        hasReportSlowRenderNew = true;
        stopIt();
        // 发送消息到主线程进行上报
        postMessage({
            cmd: 'reportNew',
            args: {
                lastRenderTime,
                nowRenderTime,
                lastFrameTime: timeFrameInter,
            },
        });
    }

    function stopIt() {
        if (hasReportSlowRenderOld && hasReportSlowRenderNew) {
            cancelAnimationFrame();
            clearSlowMonitor();
        }
    }

    function startAnimationFrame() {
        if (!hasReportSlowRenderOld || !hasReportSlowRenderNew) {
            slowRenderTimeInterval = setInterval(() => {
                slowRenderMonitor();
            }, 1000 / 60 * 3);  // 3个16ms发一次消息，防止发送过于频繁
        }
    }

    function cancelAnimationFrame() {
        if (slowRenderTimeInterval) {
            clearInterval(slowRenderTimeInterval);
            slowRenderTimeInterval = null;
        }
    }

    function clearSlowMonitor() {
        slowRenderCount = 0;
        lastRenderTimeGlobal = 0;
        nowRenderTimeGlobal = 0;
        firstSlowTime = 0; // 首次卡顿时间
        renderTimes = [];
    }

    onmessage = function (e) {
        const data = e.data;
        switch (data.cmd) {
            case 'start':
                startAnimationFrame();
                break;
            case 'stop':
                cancelAnimationFrame();
                close();
                break;
            case 'result':
                hasResultFromMain = true;
                break;
        }
    };
}


